export * from './GoogleTagManager';
